export * from './GoogleTagManager';
